import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {useUrlParam} from '../../../hooks/useUrlParam'
import {stripHtmlTags} from '../../../utils/strings'
import {TAGS_WHITELIST} from '../analysisDetail.consts'
import {NodeDetailType} from '../node-detail/nodeDetail.types'

export const QueryKey = 'node-detail'

export const useNodeDetail = (
  nodeId: string | undefined,
  options?: UseQueryOptions<NodeDetailType, AxiosError>
) => {
  const analysisId = useUrlParam('analysisId')

  return useQuery<NodeDetailType, AxiosError>({
    queryKey: [QueryKey, analysisId, nodeId],
    queryFn: async () => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/tree/nodes/${nodeId}`
      const data = (await ApiClient.axiosInstance.get<NodeDetailType>(path)).data
      data.description = stripHtmlTags(data.description, TAGS_WHITELIST)
      return data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,

    // allow the callee to override the default options
    ...options
  })
}
